// extracted by mini-css-extract-plugin
module.exports = {"uploadImageMain":"uploadImage_uploadImageMain__NNW3O","uploadImage":"uploadImage_uploadImage__1nATJ","uploadText":"uploadImage_uploadText__3ylLe"};